<template lang="html">

 <div class="wrapper-redes flex wrap justify-between" :show="show" :data="selected">

        <div class="wrapper-follow">
          <div class="">
            <p class="texto">{{$t('footer.en_redes')}}</p>
            <p class="texto">{{$t('footer.twitter')}}</p>
            <p class="texto">{{$t('footer.facebook')}}</p>
            <p class="texto">{{$t('footer.instagram')}}</p>
            <p class="texto">{{$t('footer.canal')}}</p>
          </div>
        </div>

        <ul class="f-redes flex row justify-start contenedor-redes-sociales">

          <li data="twitter" @mouseover="set('twitter')">
            <a class="fa-brands fa-x-twitter" href="https://twitter.com/search?q=Ajusa_TH&src=typd&lang=es" target="_blank"></a>
          </li>
         
         
        </ul>
        <a class="cerrar" @click="toggle">✕</a>
      </div>

</template>

<script lang="js">
  export default  {
    name: 'rrss-slide',
    props: ['show'],
    mounted() {

    },
    data() {
      return {
        selected : ''
      }
    },
    methods: {
        toggle : function(){
          this.$emit('toggle');
        },
        set : function (value){
          this.selected = value;
        }
    },
    computed: {

    }
}
</script>

<style scoped>
  .rrss-slide {

  }
</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer-parts/rrss-slide.vue